export const AdSlot = ({ label = "Advertisement", className = "", height = "h-24" }) => (
  <div
    className={`w-full ${height} border border-dashed border-border bg-secondary/40 flex flex-col items-center justify-center ${className}`}
    data-testid="ad-slot"
  >
    <span className="overline">{label}</span>
    <span className="text-xs text-muted-foreground mt-1">Google AdSense placement</span>
  </div>
);
